// Gerado por `pnpm modules:sync` a partir dos module.json (ADR 0123). Não edite à mão.
import type {
  LocalizedText,
  PermissionDefinition,
  SystemRoleDefinition,
} from '../permissions.ts';
import * as factory from './factory/permissions.ts';

/** Os módulos instalados, na ordem das dependências. */
export const INSTALLED_MODULES = [
  {
    id: 'factory',
    version: '1.0.0',
    name: { 'pt-BR': 'Smart Builder', en: 'Smart Builder' },
    depends: [],
  },
] as const;

export const MODULE_PERMISSION_MODULES: Record<string, LocalizedText> = {
  ...factory.PERMISSION_MODULES,
};

export const MODULE_PERMISSIONS = [
  ...factory.PERMISSIONS,
] as const satisfies readonly PermissionDefinition[];

/** Perfis fixos que os módulos trazem (ADR 0131); o seed os cria e mantém. */
export const MODULE_SYSTEM_ROLES: readonly SystemRoleDefinition[] = [
  ...((factory as { SYSTEM_ROLES?: readonly SystemRoleDefinition[] }).SYSTEM_ROLES ?? []),
];
